import { useFormContext } from 'react-hook-form';
import { DashboardPageFormBody, DashboardPageFormField } from '@shigo-ui/dashboard-ui';
import { Input } from '@shigo-ui/ui';

import { dashboardT } from '../../../../../lib/messages';
import type { OwnerFormValue } from '../../formSchema';

export function OwnerComplianceFields() {
  const { register, formState } = useFormContext<OwnerFormValue>();

  return (
    <DashboardPageFormBody
      width="lg"
      title={dashboardT('owners.tabs.compliance')}
      description={dashboardT('owners.compliance.description')}
    >
      <div className="grid gap-5 md:grid-cols-2">
        <DashboardPageFormField
          label={dashboardT('owners.fields.tcfVendorId')}
          htmlFor="owner-tcf-vendor-id"
          error={formState.errors.tcfVendorId?.message}
        >
          <Input id="owner-tcf-vendor-id" {...register('tcfVendorId')} />
        </DashboardPageFormField>
        <DashboardPageFormField
          label={dashboardT('owners.fields.billingEntity')}
          htmlFor="owner-billing-entity"
        >
          <Input id="owner-billing-entity" {...register('billingEntity')} />
        </DashboardPageFormField>
        <DashboardPageFormField
          label={dashboardT('owners.fields.paymentCycle')}
          htmlFor="owner-payment-cycle"
        >
          <Input id="owner-payment-cycle" {...register('paymentCycle')} />
        </DashboardPageFormField>
        <DashboardPageFormField
          label={dashboardT('owners.fields.billingEmail')}
          htmlFor="owner-billing-email"
          error={formState.errors.billingContactEmail?.message}
        >
          <Input id="owner-billing-email" type="email" {...register('billingContactEmail')} />
        </DashboardPageFormField>
      </div>
    </DashboardPageFormBody>
  );
}
